import React, { useEffect } from "react";
import { Hero } from "../../components/ui/Hero";
import { SiteFrame } from "../../components/ui/SiteFrame";
import Mixpanel from "../../lib/mixpanel";
import Seo, { SITE } from "../../components/Seo";

const personJsonLd = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: "Krushil Amrutiya",
  alternateName: ["Krushil", "Krush"],
  url: SITE.url,
  image: SITE.image,
  jobTitle: "Computer Science Senior",
  description: SITE.defaultDescription,
  alumniOf: {
    "@type": "CollegeOrUniversity",
    name: "Penn State University",
  },
  knowsAbout: ["Software Engineering", "Entrepreneurship", "Aviation"],
  sameAs: [
    "https://github.com/krushil1",
    "https://linkedin.com/in/krushil-amrutiya",
    "https://x.com/krushil_a",
  ],
};

const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE.name,
  url: SITE.url,
};

export default function HomePage() {
  useEffect(() => {
    Mixpanel.trackHome();
  }, []);

  return (
    <SiteFrame>
      <Seo
        path="/"
        description="Krushil Amrutiya — CS Senior at Penn State passionate about tech, entrepreneurship, and aviation. Explore my projects, experience, and aviation photography."
        jsonLd={[personJsonLd, websiteJsonLd]}
      />
      <Hero />
    </SiteFrame>
  );
}
